import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store.js";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
    <Toaster
      position="top-center"
      reverseOrder={false}
      gutter={8}
      // toastOptions={{
      //   duration: 4000,
      // }}
    />
  </Provider>
  // </React.StrictMode>
);

reportWebVitals();
